import React from 'react';
import styled from 'styled-components';
import { Emoji } from 'emoji-mart'

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    fontSize: '1rem',
    labelSize: '0.8rem'
}

const Container = styled.div`
    width: 100%;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    cursor: pointer;
    font-size: ${props => props.styles.fontSize};
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Row = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const Icon = styled.img`
    height: 1rem;
    width: 1rem;
    object-fit: contain;
    src: ${props => props.icon};
    margin: 0 0.5rem 0 0;
    padding: 0.2rem;
    border-radius: 5px;
    border: 1px solid var(--primary-accent-color);
    background: var(--secondary-color);
`

const Title = styled.div`
    font-weight: ${props => props.fontWeight};
    font-size: ${props => props.styles.fontSize};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
`

const Subtitle = styled.div`
    font-size: ${props => props.styles.labelSize};
    color: var(--secondary-accent-color);
`

const OptionBlock = props => {
    const {
        title,
        subtitle,
        icon,
        onSelect,
        closeHandler,
        styles
    } = props
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    const onSelectHandler = () => {
        onSelect && onSelect();
        closeHandler && closeHandler();
    }
    
    return (
        <Container onClick={onSelectHandler} styles={updatedStyle}>
            <Row>
                {!icon ? null
                : icon['type'] === 'link' ? <Icon src={icon['value']}/>
                : icon['type'] === 'emoji' ? <div style={{margin: '0 0.5rem 0 0'}}><Emoji emoji={icon['value']} size={'1rem'}/></div>
                : icon['type'] === 'element' ? <div style={{margin: '0 0.5rem 0 0', height: '1rem', width: '1rem'}}>{icon['value']}</div>
                : null}
                <Column>
                    <Title fontWeight={!subtitle ? 'normal' : 'bold'} styles={updatedStyle}>{title}</Title>
                    <Subtitle styles={updatedStyle}>{subtitle}</Subtitle>
                </Column>
            </Row>
        </Container>
    )
}

export default OptionBlock;